export enum ENTERPRISE_PARTNER_ID {
  evee = 'evee',
  ovoEnergy = 'ovo-energy',
  commbank = 'commbank',
  act = 'act',
  tas = 'tas',
  rewiringAustralia = 'rewiring-au',
  oneMillionWomen = '1mw',
  racq = 'racq',
  brighte = 'brighte',
}

export enum GROUP_STATUS {
  active = 'active',
  inactive = 'inactive',
}
